module.exports = __webpack_public_path__ + "static/media/kids_39.efd7a354.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/kids/JPEG/kids_39.jpg
// module id = 5895
// module chunks = 0